<template>
  <b-container fluid id="wrapper-login" class="p-0" :style="{ backgroundImage: `url(${bgImage})` }">
    <b-row no-gutters>
      <b-col class="col-left hv-100" v-bind:style="{ background: loginBgColor }">
        <router-link to="/">
          <b-img :src="logoHomeImg" fluid alt="Logo" class="logoSite"/>
        </router-link>
        <h4 class="mt-4">{{ $t('sign_in') }}</h4>
        <p class="mt-2">{{ $t('sign_in_message') }}</p>
        <button id="buttonLogin" class="btn btn-primary btn-margin mt-3" v-if="!isAuthenticated" @click="login()">
          <i class="mdi mdi-login"></i>
          {{ $t('sign_in_btn') }}
        </button>
        <button id="buttonLogin" class="btn btn-primary btn-margin mt-3" v-if="isAuthenticated" @click="logout()">
          <i class="mdi mdi-login"></i>
          Log Out
        </button>

        <footer class="footer footer-alt">
          <!-- <p class="text-muted">
            Don't have an account?
            <a href="" class="text-dark ml-1">
              <b>Sign Up</b>
            </a>
          </p> -->
        </footer>
      </b-col>
      <b-col class="col-right hv-100 d-none d-xl-block">
        <div class="auth-user-testimonial">
          <h2 class="mb-3">{{ title1 }}</h2>
          <p class="lead">
            <i class="mdi mdi-format-quote-open"></i>
            {{ text }}
            <i class="mdi mdi-format-quote-close"></i>
          </p>
          <p>{{ title2 }}</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'app',
  methods: {
    // uso spread operator para expendir el objeto devuelto por mapActions y poder crear métodos para la propiedad methods y aun así poder definir methods locales
    ...mapActions('session', ['login', 'logout'])
  },
  computed: {
    // uso spread operator para expendir el objeto devuelto por mapActions y poder crear métodos para la propiedad computed y aún así poder definir computed locales
    ...mapGetters('session', ['isAuthenticated']),
    ...mapState('settings', ['appName', 'logoHomeImg', 'title1', 'title2', 'text', 'bgImage', 'loginBgColor'])
  }
}
</script>

<style lang="sass" scoped>
#wrapper-login
  background-position: center
  background-size: cover
  .col-left
    padding: 48px 55px
    max-width: 480px
    width: 100%
    @media(max-width: $xl)
      max-width: none
      padding: 72px 56px
    .logoSite
      @media(max-width: $xl)
        margin: 0 auto
        display: block
    h4
      font-size: 18px
      font-weight: 700
      color: $primaryFontThemeColor
    p
      color: $mutedFontThemeColor!important
      font-size: 14px
      font-weight: 400
    #buttonLogin
      box-shadow: 0 2px 6px 0 rgba(114,124,245,.5)
      width: 100%
      color: #fff
      background-color: $primaryThemeColor
      border-color: $primaryThemeColor
      font-size: 14px
      font-weight: 400
      &:hover
        background-color: #4e5bf2
        border-color: #4250f2
  .col-right
    padding: 6rem 3rem
    -webkit-box-flex: 1
    -ms-flex: 1
    flex: 1
    position: relative
    color: #fff
    background-color: rgba(49,58,70,.6)
    text-align: center
    .auth-user-testimonial
      position: absolute
      margin: 0 auto
      padding: 0 1.75rem
      bottom: 3rem
      left: 0
      right: 0
      h2
        font-weight: 700
      p
        font-size: 14px
        &.lead
          font-weight: 400
          font-size: 18px
  .footer
    bottom: 0
    padding: 19px 30px 20px
    position: absolute
    right: 0
    color: $mutedFontThemeColor
    width: 100%
    text-align: center
</style>
